import { Injectable } from '@angular/core';

import { Config } from './config';
import { BsDatepickerConfig } from 'ngx-bootstrap';

@Injectable()
export class ConfigService {
  private config: Config = require("./config.json");

  constructor() { }

  public getUrl(): string {
    let url;
    if (process.env.PAYTRON_API_URL) {
      url = process.env.PAYTRON_API_URL;
    } else {
      url = this.config.httpHost;
      if (this.config.sslEnabled == true) {
        url = this.config.httpsHost;
      }
    }
    return url;
  }

  public getConfiguration(): Config {

    return this.config;

  }

  public getDisplayDateFormat(): string {
    return this.config.displayDateFormat;
  }

  public getDisplayTimeFormat(): string {
    return this.config.displayTimeFormat;
  }

  public getPosCode(): string {
    return this.config.posCodeId;
  }

  public getDatepickerConfig(): Partial<BsDatepickerConfig> {
    return this.config.datepickerConfig;
  }
  
  public getCardReaderWebSocketUrl(): string {
    return this.config.cardReaderWebSocketUrl;
  }
  
  public getHelpHref(): string {
    return this.config.helpHref;
  }
  
}



// WEBPACK FOOTER //
// ./src/providers/config/config.service.ts